import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

import { UserFragment } from '@/helpers/api/fragments'

const output = `
    ...User
    customer{
      number
      company_name
    }
`
const fragments = gql`
  ${UserFragment}
`

const allowedFields = [
  'email',
  'name',
  'role',
  'customer_id',
  'is_active',
  'firstname',
  'lastname'
]

export default config => {
  const { client } = config
  const service = createService({
    ...config,
    table: 'user',
    defaultFilters: [],
    defaultOutput: output,
    defaultFragments: fragments,
    allowedFields
  })

  return {
    ...service,
    updatePreference: async payload => {
      const { id, option, value } = payload

      const mutation = gql`
        mutation ($id: uuid!, $preference: jsonb) {
          update_user_by_pk(
            pk_columns: { id: $id }
            _append: { preferences: $preference }
          ) {
            preferences
          }
        }
      `

      let preference = {}
      preference[option] = value

      const {
        data: {
          update_user_by_pk: { preferences }
        }
      } = await client.mutate({
        mutation,
        variables: {
          id,
          preference
        }
      })

      return preferences[option]
    }
  }
}
